import { Component, OnInit } from '@angular/core';
import { BehaviorSubject, filter, Observable, of, switchMap, tap } from 'rxjs';
import { FiltersFormAnalytics, FitsAnalytics } from 'src/app/core/models/analytics.model';
import { Entity } from 'src/app/core/models/entity.model';
import { Category } from 'src/app/core/models/package.model';
import { Pagination, PaginationRequest } from 'src/app/core/models/pagination.model';
import { User } from 'src/app/core/models/user.model';
import { AnalyticsService } from 'src/app/core/services/analytics.service';
import { ConfigService } from 'src/app/core/services/config.service';
import * as utils from 'src/app/shared/helpers/utils';


@Component({
  selector: 'hbo-analytics-fit',
  templateUrl: './analytics-fit.component.html',
  styleUrls: ['./analytics-fit.component.scss']
})
export class AnalyticsFitComponent implements OnInit {

  user: User = utils?.localStorageGetItem('user');

  columns: string[] = [];

  data$: FitsAnalytics[] = [];

  finishedCount: number = 0;
  pendingCount: number = 0;

  categories: Category[] = [{ id: 1, name: 'OPERATIVE' }, { id: 2, name: 'DEMO' }];

  pagination!: PaginationRequest;
  filters!: FiltersFormAnalytics;
  pageBefore!: number | null;
  refreshSearch$ = new BehaviorSubject<PaginationRequest | null>(null);

  pagination$!: Pagination<Entity>;
  entitiesCollection$: Entity[] = [];
  entities$ = this.refreshSearch$.pipe(
    filter(params => !!params),
    switchMap(params => {
      return of(this.pagination$)
    }),
    tap(result => {
      this.entitiesCollection$ = result.data.map((entity: Entity) => ({ ...entity }));
      this.pagination.entities = this.entitiesCollection$.map((entity: Entity) => entity.id).join(',');
      this.analyticsSvc.fitsAnalytics({ ...this.filters, ...this.pagination, } as Pagination<any>).subscribe((response: any) => {
        this.mapping(this.entitiesCollection$, this.filters, response);
      })

    })
  );

  constructor(
    public configSvc: ConfigService,
    private analyticsSvc: AnalyticsService
  ) {

    switch (this.user.roleId) {
      case 1:
        this.columns = ['idEntity', 'opticalshop', 'codeEntity', 'team', 'category', 'finished', 'pending', 'total'];
        break;
      case 2:
        this.columns = ['idEntity', 'opticalshop', 'codeEntity', 'team', 'category', 'finished', 'pending', 'total'];
        break;
      default:
        this.columns = ['idEntity', 'opticalshop', 'codeEntity', 'team', 'category', 'finished', 'pending', 'total'];
        break;
    }
  }

  ngOnInit() {
    this.searchEntities();
  }

  searchEntities(pagination?: PaginationRequest) {
    this.pagination = pagination!;
    if (!this.pagination) this.pagination = { order: 'asc', page: 1, perPage: 10 }
    if (this.filters?.entities) this.pagination.entities = this.filters.entities!;
    else this.pagination.entities = null;
    // if entities filtered change reinit pagination to page 1
    if (this.pageBefore === this.pagination?.page!) this.pagination.page = 1
    else this.pageBefore = this.pagination?.page!;

    const groupedOpticalShopEntities = this.configSvc.currentConfigValue.childEntities!.reduce((acc, entity) => {
      const typeId = entity.entityTypeId;
      if (!acc[typeId]) {
        acc[typeId] = [];
      }
      acc[typeId].push(entity);
      return acc;
    }, {} as Record<string | number, Entity[]>);

    const ini = this.pagination?.perPage! * (this.pagination?.page! - 1);
    const end = ini + Number(this.pagination?.perPage!);
    let opticalShops: Entity[] = groupedOpticalShopEntities[4].sort((a, b) => a.id - b.id);

    //filtering entities
    if (this.pagination.entities) {
      opticalShops = opticalShops.filter((entity: Entity) => this.pagination?.entities!.split(',').map(Number).includes(entity.id));
    }
    //filtering team
    if (this.filters?.team) {
      opticalShops = opticalShops.filter((entity: Entity) => entity.team?.id === this.filters?.team);
    }
    //page entities
    let partialCollection$ = opticalShops.slice(ini, end);

    this.pagination$ = {
      total: opticalShops.length,
      perPage: this.pagination?.perPage!,
      currentPage: this.pagination?.page!,
      lastPage: Math.ceil(opticalShops.length / this.pagination?.perPage!),
      from: ini,
      to: end,
      search: this.pagination?.search!,
      entities: this.pagination?.entities!,
      data: partialCollection$
    }

    this.refreshSearch$.next(pagination ?? { order: 'asc', page: 1});
  }

  downloadCSV = () => {
    console.log('download CSV')
  }


  downloadSummary = () => {
    console.log('download summary')
  }

  reload = (e: FiltersFormAnalytics) => {
    this.filters = e;
    this.searchEntities(this.pagination);
  }

  mapping = (_entities: Entity[], _form: any, _values: any) => {
    this.data$ = [];
    _entities.map((entity: Entity) => this.data$.push({
      id: entity.id,
      name: entity.name!,
      code: entity.identityCode!,
      team: entity.team?.name! ?? '-',
      category: this.categories.find((cat: Category) => cat.id === _form?.category)?.name!,
      finished: _values.find((el: any) => el.id === entity.id).finished,
      pending: _values.find((el: any) => el.id === entity.id).pending,
      total: _values.find((el: any) => el.id === entity.id).total,
    }))
  }

  finished = (_entity: number) => {
    this.finishedCount = Math.floor(Math.random() * 1000);
    return this.finishedCount
  }

  pending = (_entity: number) => {
    this.pendingCount = Math.floor(Math.random() * 1000);
    return this.pendingCount
  }

  total = () => {
    return this.finishedCount + this.pendingCount
  }

}

